/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'ar',
  Pagination: {
    items_per_page: '/ الصفحة',
    jump_to: 'الذهاب إلى',
    jump_to_confirm: 'تأكيد',
    page: '',
    prev_page: 'الصفحة السابقة',
    next_page: 'الصفحة التالية',
    prev_5: 'خمس صفحات سابقة',
    next_5: 'خمس صفحات تالية',
    prev_3: 'ثلاث صفحات سابقة',
    next_3: 'ثلاث صفحات تالية'
  },
  DatePicker: {
    lang: {
      placeholder: 'اختيار التاريخ',
      rangePlaceholder: ['البداية', 'النهاية'],
      locale: 'ar_EG',
      today: 'اليوم',
      now: 'الأن',
      backToToday: 'العودة إلى اليوم',
      ok: 'تأكيد',
      clear: 'مسح',
      month: 'الشهر',
      year: 'السنة',
      timeSelect: 'اختيار الوقت',
      dateSelect: 'اختيار التاريخ',
      monthSelect: 'اختيار الشهر',
      yearSelect: 'اختيار السنة',
      decadeSelect: 'اختيار العقد',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'الشهر السابق (PageUp)',
      nextMonth: 'الشهر التالى(PageDown)',
      previousYear: 'العام السابق (Control + left)',
      nextYear: 'العام التالى (Control + right)',
      previousDecade: 'العقد السابق',
      nextDecade: 'العقد التالى',
      previousCentury: 'القرن السابق',
      nextCentury: 'القرن التالى'
    },
    timePickerLocale: {
      placeholder: 'اختيار الوقت'
    },
    dateFormat: 'DD-MM-YYYY',
    monthFormat: 'MM-YYYY',
    dateTimeFormat: 'DD-MM-YYYY HH:mm:ss',
    weekFormat: 'wo-YYYY'
  },
  TimePicker: {
    placeholder: 'اختيار الوقت'
  },
  Calendar: {
    lang: {
      placeholder: 'اختيار التاريخ',
      rangePlaceholder: ['البداية', 'النهاية'],
      locale: 'ar_EG',
      today: 'اليوم',
      now: 'الأن',
      backToToday: 'العودة إلى اليوم',
      ok: 'تأكيد',
      clear: 'مسح',
      month: 'الشهر',
      year: 'السنة',
      timeSelect: 'اختيار الوقت',
      dateSelect: 'اختيار التاريخ',
      monthSelect: 'اختيار الشهر',
      yearSelect: 'اختيار السنة',
      decadeSelect: 'اختيار العقد',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'الشهر السابق (PageUp)',
      nextMonth: 'الشهر التالى(PageDown)',
      previousYear: 'العام السابق (Control + left)',
      nextYear: 'العام التالى (Control + right)',
      previousDecade: 'العقد السابق',
      nextDecade: 'العقد التالى',
      previousCentury: 'القرن السابق',
      nextCentury: 'القرن التالى'
    },
    timePickerLocale: {
      placeholder: 'اختيار الوقت'
    },
    dateFormat: 'DD-MM-YYYY',
    monthFormat: 'MM-YYYY',
    dateTimeFormat: 'DD-MM-YYYY HH:mm:ss',
    weekFormat: 'wo-YYYY'
  },
  global: {
    placeholder: 'يرجى التحديد'
  },
  Table: {
    filterTitle: 'الفلاتر',
    filterConfirm: 'تأكيد',
    filterReset: 'إعادة ضبط',
    selectAll: 'اختيار الكل',
    selectInvert: 'إلغاء الاختيار',
    selectionAll: 'حدد جميع البيانات',
    sortTitle: 'رتب',
    expand: 'توسيع الصف',
    collapse: 'طي الصف',
    triggerDesc: 'ترتيب تنازلي',
    triggerAsc: 'ترتيب تصاعدي',
    cancelSort: 'إلغاء الترتيب'
  },
  Modal: {
    okText: 'تأكيد',
    cancelText: 'إلغاء',
    justOkText: 'تأكيد'
  },
  Popconfirm: {
    okText: 'تأكيد',
    cancelText: 'إلغاء'
  },
  Transfer: {
    searchPlaceholder: 'ابحث هنا',
    itemUnit: 'عنصر',
    itemsUnit: 'عناصر'
  },
  Upload: {
    uploading: 'جاري الرفع...',
    removeFile: 'احذف الملف',
    uploadError: 'مشكلة فى الرفع',
    previewFile: 'استعرض الملف',
    downloadFile: 'تحميل الملف'
  },
  Empty: {
    description: 'لا توجد بيانات'
  },
  Icon: {
    icon: 'أيقونة'
  },
  Text: {
    edit: 'تعديل',
    copy: 'نسخ',
    copied: 'تم النسخ',
    expand: 'المزيد'
  },
  PageHeader: {
    back: 'عودة'
  }
};
